import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Consulting = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Consulting</h1>
                <p className="colorWht">Operating environment for global organizations is increasingly getting complex.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/consulting.jpg" alt="consulting" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Operating environment for global organizations is increasingly getting complex. While IT is no longer a support function in an organization, transformation of functional areas needs to be in harmony with the business strategy too. As change becomes the new normal in the business world, organizations today need to reinvent in order to excel.
              </p>
              <p>
                GCS helps you achieve and sustain this success through strategic, functional and process transformation that enables you improve performance, increase effectiveness, reduce costs and enhance resilience.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside consulting">
                <div>You may also be interested in <span> our other services</span></div>
                <ul className="pad0">
                  <li><Link to="/applications" title="Applications">Applications</Link></li>
                  <li><Link to="/enterprise-resource-planning" title="ERP">ERP</Link></li>
                  <li><Link to="/mobility" title="Mobility">Mobility</Link></li>
                  <li><Link to="/business-process" title="Business Process">Business Process</Link></li>
                  <li><Link to="/gps-tracking-service" title="GPS Tracking as Service">GPS Tracking as Service</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>How Green Orange Helps?</h2>
                <p>
                  GreenOrange Consulting Services (GCS) is a key differentiator for GreenOrange Information Technology Private Limited. GCS consults and leads organizational and business process transformation to improve performance, increase effectiveness, reduce costs and improve resilience. We introduce leading edge practices and offer business advisory, business and functional transformation, IT consulting and risk and compliance services.
                </p>
                <p>
                  In the role of a trusted advisor, GCS consistently delivers solutions that are measurable, implementable and customized to your requirements. GCS's transformational approach helps organizations capture value through innovation, disruptive growth and business effectiveness, while also shifting the focus from Optimized Operations to Investing in Changing-The-Business.
                </p>
                <p>WCS offers services in the following areas:</p>
                <h4>Business Transformation</h4>
                <p>
                  Organizations are continuously trying to transform their business models to address changing customer needs, consolidate market positions and to expand into new segments and geographies. Moreover, globalization, digitization, shift in economic growth regions, changes in energy costs and adoption of newer technologies across industries are changing the dynamics of business faster than ever before. These changes in marketplace dynamics call for changes in business strategy and models.
                </p>
                <p>
                  GreenOrange's Business Transformation Solutions help you come up with an operating model that delivers the desired business outcome at all scales. Our operating models are simple, flexible and resilient, helping you grasp business opportunities while also optimizing cost and productivity.
                </p>
                <h4>IT Transformation</h4>
                <p>
                  IT is no longer a support function in an organization and is seen as a key business driver. Data analytics, HR tools, CRM and even personal devices have become the backbone to enable an organization function efficiently. Such trends are impacting the very fabric of business in more ways than we can estimate.
                </p>
                <p>
                  Continual improvement of the technology landscape within an organization through system consolidation and process engineering, adoption of specialized ERP tools over consolidated ERP, adoption of software, process and hardware as a service, outsourcing of technology to cheaper locations, enablement of higher IT security measures in a cloud environment are trends which are impacting the decisions of CIOs and CTOs across the world.
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Consulting;

